import React, { useState, useEffect } from 'react';
import {  Checkbox, Tooltip, notification, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Upload, DatePicker, Input, Spin } from 'antd';
import { useParams } from 'react-router-dom';

import Modal from '../../../../components/uiComponent/modal/index';
import { AiOutlineDelete } from 'react-icons/ai';
import { GetPresignedUrl } from '../../../../slices/aws-services.js';
import FileIcon from '../../../../assets/icons/file-icon.svg';
import { DeleteReceivedHistory, getWarehousePoDetails, GetWarehousePoHistory, UpdatePo, GetPoItems, GetPoDetails } from '../../../../slices/po.js';
import { DrawerWrapper, BottomSectionWrapper, ModalWrapper } from './style.js';
import leftArrowIcon from '../../../../assets/icons/left-arrow.svg';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import uploadIcon from '../../../../assets/icons/uploadIcon-1.svg';
import WarningIcon from '../../../../assets/icons/warning-modal-icon.svg';
import { CreateReceiveHistory } from '../../../../slices/po';
import ReactSelect from '../../../../components/uiComponent/select/index.js';
import { reasonOptions } from '../../../../constants/warehousePo.js';
import ProductImg from '../../../../assets/images/newImages/nestle.svg';
import { convertUtcToEst } from '../../../../utils/helpers.js';
const { Dragger } = Upload;

const ReceiveProductDrawer = ({
  po_status,
  poId,
  visible,
  onClose,
  rowData,
  filters = {},
  page = 1
}) => {
  const po_item_id = useParams();
  const dispatch = useDispatch();
  const { id } = rowData || {};
  const [selectedData, setSelectedData] = useState(rowData);
  const [isLoosepack, setIsLoosepack] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timeStamp,setTimeStamp] = useState(null)
  const [loading,setLoading] = useState(false)
  const [receivingModalOpen, setReceivingModalOpen] = useState(false)
  const { createReceivingLoading, deleteReceivingLoading } = useSelector((state) => state.pos || {});
  const { currentUser } = useSelector((state) => state.auth || {});
  const [formData, setFormData] = useState({
    quantity: null,
    expiry_date: null,
    no_of_cases: null,
    in_a_case: null,
    unsellable_quantity: null,
    reason: null,
    isLoosepack: isLoosepack,
  });
  const { warehousePoHistory } = useSelector((state) => state.pos || {}); 

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value === null || value.trim() === '' ? null : value.trim(),
    }));
  };

  const addReceivingDisableStatus = () => {
    const {unsellable_quantity, quantity, no_of_cases, in_a_case, reason } = formData || {};
    if (
      !unsellable_quantity &&
      !quantity &&
      (!no_of_cases || !in_a_case)
    ) return true;
    if (formData.reason && !unsellable_quantity || !reason && unsellable_quantity) return true;
  };

  const handleValidateQty = () =>{ 

    const { quantity = 0, unsellable_quantity = 0, no_of_cases = 0, in_a_case = 0 } = formData || {};

    if( Number(selectedData?.received_quantity) + Number(quantity) + Number(unsellable_quantity)+
     ( Number(in_a_case) * Number(no_of_cases) ) > Number(selectedData?.invoice_quantity)){
      setReceivingModalOpen(true)
    }
    else { handleImageUpload() };
  }

  const handleImageUpload = async () => {

    if (selectedFiles?.length === 0 ) {
      handleSubmit();
      return;
    }

    try {
     
      setLoading(true)
      const response = await dispatch(
        GetPresignedUrl({ files: selectedFiles })
      );
      const attachments = response?.payload;
      const fileUrls = attachments?.map((attachment) => attachment?.url);

      message.success('Files uploaded successfully!');
      setLoading(false)
      await handleSubmit(fileUrls);
    } catch (error) {
      console.error('Upload error:', error);
      message.error('File upload failed.');
    } finally {
      setSelectedFiles([]);
    }
  };

  const handleSubmit = async (fileUrls) => {
    setFormData({ ...formData, urls: fileUrls });
    let isReceived = false;
    const { quantity = 0, unsellable_quantity = 0, no_of_cases = 0, in_a_case = 0 } = formData || {};
    if ( Number(selectedData?.received_quantity) + Number(quantity) + Number(unsellable_quantity)+
    ( Number(in_a_case) * Number(no_of_cases) ) >= Number(selectedData?.invoice_quantity)) {
      isReceived = true;
    }
    dispatch(
      CreateReceiveHistory({
        ...formData,
        urls: fileUrls,
        po_item_id: rowData?.id,
        product_id:rowData?.product?.id,
        is_received: isReceived,
        poId
      })
    ).then(({ payload }) => {
      if (payload?.success) {
        if(po_status != "Receiving"){
          dispatch(UpdatePo({ poId, status:"Receiving" })).then(({payload})=>{
              refreshPage();
            })

        } else {
          notification['success' ]({
            message:'PO Received Successfully',
            top: 20,
          });
          refreshPage()
        }
        
      }
    });
  };

  const handleFileChange = (info) => {
    setSelectedFiles((prev) => [...prev, info?.file]);
  };
  const handleFileDelete = (fileToDelete) => {
    setSelectedFiles((prevFiles) =>
      prevFiles?.filter((file) => file.name !== fileToDelete.name)
    );
  };
  const handleDeleteHistory = async () => {
    dispatch(DeleteReceivedHistory({ po_item_id: rowData?.id, timestamp: timeStamp })).then(
      ({ payload }) => {
        if (payload?.success) {
          handleClose();
          notification['success' ]({
            message:'Receiving History Deleted Successfully',
            top: 20,
          });
          refreshPage();
        }
      });
  
  };
  const resetFormData = () => {
    setFormData({
      quantity: null,
      expiry_date: null,
      no_of_cases: null,
      in_a_case: null,
      unsellable_quantity: null,
      reason: null,
      isLoosepack: true, 
    });
    setIsLoosepack(true); 
    setSelectedFiles([]); 
  };
  const handleClose = () => {
    resetFormData();
    setIsModalOpen(false);
    setReceivingModalOpen(false);
  };
  const handleOpen = (timestamp)=>{
    setIsModalOpen(true);
    setTimeStamp(timestamp)
  }
  const refreshPage = ()=>{
    setTimeStamp(null);
    setFormData({
      quantity: null,
      expiry_date: null,
      no_of_cases: null,
      in_a_case: null,
      unsellable_quantity: null,
      reason: null,
      isLoosepack: isLoosepack,
    });
    dispatch(GetWarehousePoHistory({po_item_id:id}))
    const isSellerPlusWarehouse = currentUser.role.id === 5;
    const checkPoId = isSellerPlusWarehouse ? po_item_id.poId : po_item_id.id
    if (isSellerPlusWarehouse){
      dispatch(GetPoItems({id:po_item_id.poId, filters, page}))
      dispatch(GetPoDetails(po_item_id.poId))
    }
    dispatch(getWarehousePoDetails({ id: checkPoId, filters })).then(({ payload }) => {
      const updatedData = payload?.data?.filter((record) => record.id === rowData.id)
      setSelectedData(updatedData?.[0])
    })
  }
  useEffect(() => {
    if (rowData) {
      setSelectedData(rowData);
    }
  }, [rowData]);

  useEffect(() => {
    if (!visible) {
      resetFormData();
    }
  }, [visible]);

  return (
    <DrawerWrapper
      placement='right'
      onClose={onClose}
      visible={visible}
      width={536}
    >
      <div className='upper-div'>
        <div className='receive-product' onClick={onClose}>
          <div className='arrow-icon'>
            <img src={leftArrowIcon} alt='Left Arrow' />
          </div>
          Receive Product
        </div>
        <div className='product'>
          <div className='image-div'>
            <div className='image-container'>
              <img
                src={selectedData?.product?.image_url || ProductImg}
                alt='Img'
                title='ProductImg'
              />
            </div>
          <div className='content-div'>
             <span className='heading-text'>Name</span>
             <Tooltip placement='top' title={selectedData?.product?.name?.length > 28 ? selectedData?.product?.name : null}>
              <span className='value-text'>{selectedData?.product?.name?.length > 28 ? selectedData?.product?.name.slice(0, 28) + '...' : selectedData?.product?.name || 'N/A'}</span>
              </Tooltip> 
              <div className='quantity-section'>
                <div className='section-items'>
                  <span className='heading-text'>Invoice Qty</span>
                  <span className='value-text'>{selectedData?.invoice_quantity || 0}</span>
                </div>
                <div className='section-items'>
                  <span className='heading-text'>Received Qty</span>
                  <span className='value-text'>{selectedData?.received_quantity || 0}</span>
                </div>
                <div className='section-items'>
                  <span className='heading-text'>Brand</span>
                  <span className='value-text'>{selectedData?.product?.brand || 'N/A'}</span>
                </div>
                <div className='section-items'>
                  <span className='heading-text'>{selectedData?.product?.identifier_type?.toUpperCase() || 'N/A'}</span>
                  <span className='value-text'>{selectedData?.product?.identifier_value || '-'}</span>
                </div>
              </div>
             
          </div>
          </div>
        </div>
        <div className='sellable'>
          <div className='sellable-top'>
            <span className='blue-span'>Sellable</span>
            <div className='buttons'>
              <button
                className={
                  isLoosepack
                    ? 'contained simple-button loose-pack-button'
                    : 'outlined simple-button loose-pack-button'
                }
                onClick={() => {
                  setIsLoosepack(true);
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    no_of_cases: null,
                    in_a_case: null,
                    expiry_date: null,
                    isLoosepack: true,
                  }));
                }}
              >
                Loose Pack
              </button>
              <button
                className={
                  isLoosepack
                    ? 'outlined simple-button case-pack-button'
                    : 'contained simple-button case-pack-button'
                }
                onClick={() => {
                  setIsLoosepack(false);
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    quantity: null,
                    expiry_date: null,
                    isLoosepack: false,
                  }));
                }}
              >
                Case Pack
              </button>
            </div>
          </div>
          <div className='sellable-bottom'>
            {isLoosepack ? (
              <div className='input-section'>
                <div className='loose-pack-divs'>
                  <span>Quantity</span>
                  <Input
                    placeholder='Enter quantity'
                    value={formData.quantity}
                    required={isLoosepack}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && Number(value) >= 0) {
                        handleInputChange('quantity', value);
                      }
                    }}
                  />
                </div>
                <div className='loose-pack-divs'>
                  <span>Expiry Date</span>
                  <DatePicker
                    placeholder='Select'
                    required={isLoosepack}
                    value={
                      formData.expiry_date ? moment(formData.expiry_date) : null
                    }
                    onChange={(date, dateString) =>
                      handleInputChange('expiry_date', dateString)
                    }
                  />
                </div>
              </div>
            ) : (
              <div className='case-pack'>
                <div className='input-divs'>
                  <span>No. of Cases</span>
                  <Input
                    placeholder='Enter'
                    value={formData.no_of_cases}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && Number(value) >= 0) {
                        handleInputChange('no_of_cases', value);
                      }
                    }}
                  />
                </div>
                <div className='input-divs'>
                  <span>In a Case</span>
                  <Input
                    placeholder='Enter'
                    value={formData.in_a_case}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && Number(value) >= 0) {
                        handleInputChange('in_a_case', value);
                      }
                    }}
                  />
                </div>
                <div className='input-divs'>
                  <span>Expiry Date</span>
                  <DatePicker
                    placeholder='Select'
                    value={
                      formData.expiry_date ? moment(formData.expiry_date) : null
                    } 
                    onChange={(date, dateString) =>
                      handleInputChange('expiry_date', dateString)
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='unsellable'>
          <span className='blue-span'>Unsellable</span>
          <div className='input-section'>
            <div className='loose-pack-divs'>
              <span>Quantity</span>
              <Input
                placeholder='Enter'
                value={formData.unsellable_quantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (!isNaN(value) && Number(value) >= 0) {
                    handleInputChange('unsellable_quantity', value);
                  }
                }}  
              />
            </div>
            <div className='loose-pack-divs'>
              <ReactSelect
              label='Reason'
              options={reasonOptions}
              value={formData.reason ? reasonOptions.find(option => option.value === formData.reason) : null}
              onChange={(selected) => handleInputChange('reason', selected ? selected.value : null)}
              placeholder='Select Reason'
              isClearable={true}
            />
            </div>
          </div>
        </div>
        <div className='file-input'>
          <span>Upload Image's</span>
          <Dragger
            name='file'
            multiple
            accept='.jpg,.jpeg,.png'
            className='custom-dragger'
            beforeUpload={() => false}
            onChange={handleFileChange}
            fileList={selectedFiles.map((file) => ({
              uid: file.uid || file.name,
              name: file.name,
              status: 'done', 
            }))}
            showUploadList={false}
          >
            <div className='upload-wrapper'>
              <img src={uploadIcon} alt='uploadIcon' title='uploadIcon' />
              <p>Drag & Drop or Click to Upload images</p>
            </div>
          </Dragger>
          {selectedFiles && (
            <>
              <h6>Uploaded Files</h6>
              <div className='uploaded-file-container'>
                {selectedFiles?.map((file) => (
                  <div key={file.uid} className='uploading-content-data'>
                    <div className='title'>
                      <img src={FileIcon} alt='File Icon' title='File Icon' />
                      <span>{file.name}</span>
                    </div>
                    <AiOutlineDelete
                      onClick={() => handleFileDelete(file)}
                      style={{ cursor: 'pointer', color: 'red' }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        <div className='lower-buttons-class'>
          <button className='cancel-button' onClick={onClose}>Cancel</button>
          <button
          className={`save-button ${po_status === "Processed" ||  po_status?.toLowerCase() === 'confirmed' || addReceivingDisableStatus() ? "save-button disabled-save-button" : "save-button"}`}
          onClick={handleValidateQty}
          disabled={createReceivingLoading || loading || po_status === "Processed" || po_status?.toLowerCase() === 'confirmed'} 
        >
          {createReceivingLoading || loading ? (
            <span>
              <Spin size='small' /> Saving...
            </span> 
          ) : (
            'Save'
          )}
        </button>
        </div>
      </div>
      <BottomSectionWrapper>
        <div className='table-container'>
          <span className='table-title'>Receive History</span>

          <table className='custom-table'>
            <thead>
              <tr>
                <th className='date-cell'>Date</th>
                <th className='sellable-cell'>Sellable</th>
                <th className='empty'></th>
                <th className='empty'></th>
                <th className='expiry-date'>Expiry Date</th>
                <th className='unsellable-cell'>Unsellable</th>
                <th className='action-cell'>Action</th>
              </tr>
            </thead>
            {warehousePoHistory.length === 0 ? 
                         <div className='no-data'>No Data Found</div>  
                         :
            <tbody>
              {warehousePoHistory.map((row, index) =>
                row.pack_type === 'case-pack' && row.no_of_cases ? (
                  <tr key={row.timestamp}>
                     <td>
                      <div className='date-time-wrapper'>
                        <span>{convertUtcToEst(row.timestamp, { month: '2-digit', day: '2-digit', year: 'numeric' })}</span>
                        <span>{convertUtcToEst(row.timestamp, { hour: '2-digit', minute: '2-digit', hour12: true })} </span>
                      </div>
                    </td>
                    <td className=''>
                      <span>{row.no_of_cases}</span>
                      <small>No of cases</small>
                    </td>
                    <td className='case-pack-cell'>
                      <span>{row.in_a_case}</span>
                      <small>In a case</small>
                    </td>
                    <td className='case-pack-cell'>
                      <span>{row.sellable_quantity || 0}</span>
                      <small>Units</small>
                    </td>
                    <td>{row.expiry_date ? convertUtcToEst(row.expiry_date, { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}</td>
                    <td>{row.unsellable_quantity}</td>
                    <td>
                      <DeleteOutlinedIcon
                      className={`delete-icon ${po_status === "Processed" ? "disabled-icon disabled-class" : ""}`}
                      onClick={() => handleOpen(row.timestamp)}
                      />
                    </td>
                  </tr>
                ) : (
                  <tr key={row.timestamp}>
                    <td>
                      <div className='date-time-wrapper'>
                          <span>
                            {
                              convertUtcToEst(row.timestamp, { month: '2-digit', day: '2-digit', year: 'numeric' })
                            }
                          </span>
                          <span>
                            {                                        
                              convertUtcToEst(row.timestamp, { hour: '2-digit', minute: '2-digit', hour12: true })
                            }
                          </span>
                      </div>
                    </td>
                    {row.sellable_quantity ? (
                      <td className='loosepack-cell'>
                        <span>{row.sellable_quantity}</span>
                        <small>Units</small>
                      </td>
                    ) : (
                      <td>0</td>
                    )}

                    <td></td>
                    <td></td>
                    <td>{row.expiry_date ? convertUtcToEst(row.expiry_date, { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}</td>
                    <td>{row.unsellable_quantity}</td>
                    <td >
                      <DeleteOutlinedIcon
                        className={`delete-icon ${po_status === "Processed" ? "disabled-icon disabled-class" : ""}`}
                        onClick={() => handleOpen(row.timestamp)}
                      />
                    </td>
                  </tr>
                )
              )}
            </tbody>
           }
          </table>
        </div>
      </BottomSectionWrapper>
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        onHide={handleClose}
        closeText='Cancel'
        // saveText='Confirm'
        buttonDisabled = {deleteReceivingLoading }
        saveText={ deleteReceivingLoading? <Spin size='small' /> : 'Confirm'} 
        header='Delete Confirmation'
        className='delete-confirmation-modal'
        closeButton={true}
        onSave={() => {
          handleDeleteHistory();
        }}
      >
        <ModalWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <h3>Warning</h3>           
              <p>Are you sure you want to delete this Receive History ?</p>
          </div>
          </ModalWrapper>
      </Modal>
      <Modal
        open={receivingModalOpen}
        onClose={handleClose}
        onHide={handleClose}
        closeText='Cancel'
        saveText='Confirm'
        header='Receive Confirmation'
        className='delete-confirmation-modal'
        closeButton={true}
        onSave={() => {
          setReceivingModalOpen(false)
          handleImageUpload();
        }}
      >
        <ModalWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <h3>Warning</h3>           
              <p>The received quantity exceeds the invoice quantity.</p>
              <p> Do you still want to proceed?</p>
          </div>
          </ModalWrapper>
      </Modal>
    </DrawerWrapper>
  );
};

export default ReceiveProductDrawer;
